export enum OnboardingRequestStatuses {
    draft = 'draft',
    published = 'published',
    empty = 'empty',
    toConfirm = 'toConfirm',
    toVerify = 'toVerify',
    archived = 'archived',
}
